import { FC } from 'react';

import { SavedSearches } from '@bvi/dashboard/widgets/saved-searches';

export const SavedSearchesPage: FC = () => {
  return <SavedSearches />;
};
